/** The 37 source rows cover 39 identities; the UTM row covers three fields. */
export const CRM_FILTER_TAXONOMY_DATA_CHECKS = [
  {
    row: 1,
    sourceField: "Contact status",
    categoryNumber: 1,
    likelySource: "CRM",
    fieldIds: ["contact_status"],
  },
  {
    row: 2,
    sourceField: "Partner sourced",
    categoryNumber: 12,
    likelySource: "CRM or signup",
    fieldIds: ["partner_sourced"],
  },
  {
    row: 3,
    sourceField: "Billed through partner",
    categoryNumber: 12,
    likelySource: "Stripe",
    fieldIds: ["billed_through_partner"],
  },
  {
    row: 4,
    sourceField: "Partner tier",
    categoryNumber: 12,
    likelySource: "No partner levels defined yet",
    fieldIds: ["partner_tier"],
  },
  {
    row: 5,
    sourceField: "Created from form",
    categoryNumber: 14,
    likelySource: "Forms",
    fieldIds: ["created_from_form"],
  },
  {
    row: 6,
    sourceField: "Payment status",
    categoryNumber: 15,
    likelySource: "Stripe",
    fieldIds: ["payment_status"],
  },
  {
    row: 7,
    sourceField: "Payment recovered date",
    categoryNumber: 15,
    likelySource: "Stripe",
    fieldIds: ["payment_recovered_date"],
  },
  {
    row: 8,
    sourceField: "Plan — Has upgraded / Has downgraded",
    categoryNumber: 15,
    likelySource: "Stripe",
    fieldIds: ["plan"],
  },
  {
    row: 9,
    sourceField: "Billing interval",
    categoryNumber: 15,
    likelySource: "Stripe",
    fieldIds: ["billing_interval"],
  },
  {
    row: 10,
    sourceField: "Lifetime value",
    categoryNumber: 15,
    likelySource: "Already on the CRM dashboards",
    fieldIds: ["lifetime_value"],
  },
  {
    row: 11,
    sourceField: "Monthly recurring revenue",
    categoryNumber: 15,
    likelySource: "Already on the partner dashboard",
    fieldIds: ["monthly_recurring_revenue"],
  },
  {
    row: 12,
    sourceField: "Discount applied",
    categoryNumber: 15,
    likelySource: "Stripe",
    fieldIds: ["discount_applied"],
  },
  {
    row: 13,
    sourceField: "Refund",
    categoryNumber: 15,
    likelySource: "Stripe",
    fieldIds: ["refund"],
  },
  {
    row: 14,
    sourceField: "Churn reason",
    categoryNumber: 15,
    likelySource: "Part Stripe, part manual",
    fieldIds: ["churn_reason"],
  },
  {
    row: 15,
    sourceField: "Trial started date",
    categoryNumber: 15,
    likelySource: "Stripe",
    fieldIds: ["trial_started_date"],
  },
  {
    row: 16,
    sourceField: "Next renewal date",
    categoryNumber: 15,
    likelySource: "Stripe",
    fieldIds: ["next_renewal_date"],
  },
  {
    row: 17,
    sourceField: "Email failed",
    categoryNumber: 18,
    likelySource: "Email provider",
    fieldIds: ["email_failed"],
  },
  {
    row: 18,
    sourceField: "Email consent",
    categoryNumber: 18,
    likelySource: "Email & Comms",
    fieldIds: ["email_consent"],
  },
  {
    row: 19,
    sourceField: "Email suppressed",
    categoryNumber: 18,
    likelySource: "Email provider",
    fieldIds: ["email_suppressed"],
  },
  {
    row: 20,
    sourceField: "Suppression reason",
    categoryNumber: 18,
    likelySource: "Email provider",
    fieldIds: ["suppression_reason"],
  },
  {
    row: 21,
    sourceField: "Email send type",
    categoryNumber: 18,
    likelySource: "Email & Comms",
    fieldIds: ["email_send_type"],
  },
  {
    row: 22,
    sourceField: "Email source",
    categoryNumber: 18,
    likelySource: "Email & Comms",
    fieldIds: ["email_source"],
  },
  {
    row: 23,
    sourceField: "Feature request status",
    categoryNumber: 21,
    likelySource: "No process scoped yet",
    fieldIds: ["feature_request_status"],
  },
  {
    row: 24,
    sourceField: "Alert type",
    categoryNumber: 19,
    likelySource: "Live Alert Feed",
    fieldIds: ["alert_type"],
  },
  {
    row: 25,
    sourceField: "Alert overdue",
    categoryNumber: 19,
    likelySource: "Live Alert Feed",
    fieldIds: ["alert_overdue"],
  },
  {
    row: 26,
    sourceField: "Workflow step",
    categoryNumber: 20,
    likelySource: "Automation Centre",
    fieldIds: ["workflow_step"],
  },
  {
    row: 27,
    sourceField: "Workflow exit reason",
    categoryNumber: 20,
    likelySource: "Automation Centre",
    fieldIds: ["workflow_exit_reason"],
  },
  {
    row: 28,
    sourceField: "Industry",
    categoryNumber: 22,
    likelySource: "CRM profile",
    fieldIds: ["industry"],
  },
  {
    row: 29,
    sourceField: "Country",
    categoryNumber: 22,
    likelySource: "Business profile",
    fieldIds: ["country"],
  },
  {
    row: 30,
    sourceField: "Timezone",
    categoryNumber: 22,
    likelySource: "Business profile or account",
    fieldIds: ["timezone"],
  },
  {
    row: 31,
    sourceField: "Annual revenue",
    categoryNumber: 22,
    likelySource: "Xero / QuickBooks",
    fieldIds: ["annual_revenue"],
  },
  {
    row: 32,
    sourceField: "Annual expenses",
    categoryNumber: 22,
    likelySource: "Xero / QuickBooks",
    fieldIds: ["annual_expenses"],
  },
  {
    row: 33,
    sourceField: "Employees",
    categoryNumber: 22,
    likelySource: "Xero / QuickBooks payroll",
    fieldIds: ["employees"],
  },
  {
    row: 34,
    sourceField: "Transactions per month",
    categoryNumber: 22,
    likelySource: "Xero / QuickBooks",
    fieldIds: ["transactions_per_month"],
  },
  {
    row: 35,
    sourceField: "Bank accounts connected",
    categoryNumber: 22,
    likelySource: "Xero / QuickBooks",
    fieldIds: ["bank_accounts_connected"],
  },
  {
    row: 36,
    sourceField: "Signup source",
    categoryNumber: 23,
    likelySource: "Signup or forms",
    fieldIds: ["signup_source"],
  },
  {
    row: 37,
    sourceField: "UTM source, campaign, medium",
    categoryNumber: 23,
    likelySource: "Forms and signup capture",
    fieldIds: ["utm_source", "utm_campaign", "utm_medium"],
  },
] as const;
